import { useTheme as baseUseTheme } from '@material-ui/core';
export function useTheme() {
    return baseUseTheme();
}
//# sourceMappingURL=Theme.js.map